import { GlobalSearchItem } from "./GlobalSearch.types";

/**
 * The row's filter key / accessible name. `untitledLabel` stands in for a hit
 * whose title the backend could not resolve — a reference is never announced as
 * its raw id.
 */
export const getOptionLabel = (option: GlobalSearchItem, untitledLabel: string): string => {
  switch (option.type) {
    case "user":
      return [option.user.name, option.user.surname].filter(Boolean).join(" ").trim();
    case "tournament":
      return option.tournament.title;
    case "license":
      return option.license.title;
    case "club":
      return option.club.name;
    case "league":
      return option.league.title;
    case "team":
      return option.team.title;
    case "transaction":
      return option.transaction.id;
    case "organization":
      return option.organization.name;
    case "platform":
      return option.platform.title;
    case "page":
      return option.title;
    case "rankingRule":
    case "rankingCategory":
    case "tournamentCategory":
    case "rankingPointBlock":
    case "news":
    case "partner":
    case "album":
      return option.title ?? untitledLabel;
  }
};
